import MFA_CHOICE from "constants/mfaChoice";

export default function mapPropsToValues() {
  return {
    choice: MFA_CHOICE.EMAIL,
  };
}
